import { ToolsContext } from "../ToolsContext";
import { Stops } from "../features/stops/Stops";
import { Routes } from "../features/routes/Routes";
import React, { useContext } from "react";
import { Trips } from "../features/trips/Trips";
import { Calendars } from "../features/calendars/Calendars";
import { CalendarPicker } from "../features/calendars/CalendarPicker";
import { Segments } from "../features/segments/Segments";


export function Sidebar() {
    const tool = useContext(ToolsContext);
    let panel = (<></>);
    switch (tool.name) {
        case 'stopsTool':
            panel = (
                <Stops />
            );
            break;
        case 'segmentsTool':
            panel = (
                <Segments />
            );
            break;
        case 'routesTool':
            panel = (
                <Routes />
            );
            break;
        case 'calendarsTool':
            panel = <CalendarPicker />
            break;
        case 'tripsTool':
            panel = (
                <Trips />
            );
            break;
        default:
            panel = (<div>Wybierz narzędzie na górze...</div>);
    }

    return (
        <>
            <div style={{ width: '100%', height: '85vh' }}>
                {panel}
            </div>
        </>
    )
}